import { useEffect, useState } from "react";
import { apis, models } from "@vote4dance/judging-sdk";
const CaptchaSource = models.server.CaptchaSource;
export const useCaptchaKey = () => {
    const [captchaKey, setCaptchaKey] = useState(undefined);
    useEffect(() => {
        let active = true;
        apis.Api.read(CaptchaSource.url)
            .then((result) => {
            if (!active) {
                return;
            }
            if (result === null || result === void 0 ? void 0 : result.key) {
                setCaptchaKey(result.key);
            }
            else {
                setCaptchaKey(null);
            }
        })
            .catch(() => {
            if (active) {
                setCaptchaKey(null);
            }
        });
        return () => {
            active = false;
        };
    }, []);
    return captchaKey;
};
